import React from "react";
import { TextInput, View, StyleSheet } from "react-native";
import Label from "../Label";
import t from "@constants/localization";

const PATH = "components/DeleteCXModal";

const TextAreaNumber = ({ value, onSubmit, formItem = {} }) => {
  const { label } = formItem;
  return (
    <>
      <Label label={label} />
      <View style={styles.textInputContainer}>
        <TextInput
          value={value}
          placeholder={t(`${PATH}/typeHere`)}
          onChangeText={onSubmit}
          style={styles.textArea}
          keyboardType="number-pad"
          maxLength={10}
        />
      </View>
    </>
  );
};

export default TextAreaNumber;

const styles = StyleSheet.create({
  textInputContainer: {
    borderWidth: 1,
    borderRadius: 6,
    borderColor: "rgba(0, 0, 0, 0.2)",
    backgroundColor: "white",
    padding: 15,
  },
  textArea: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    lineHeight: 22,
    minHeight: 10,
    justifyContent: "center",
    textAlignVertical: "center",
  },
});
